import { CSSProperties, memo } from "react"

interface LineNumberDisplayProps {
    value: string
    isVisible: boolean
    containerRef?: React.RefObject<HTMLDivElement | null>
    style?: CSSProperties
}

const LineNumberDisplayComponent = ({ value, isVisible, containerRef, style }: LineNumberDisplayProps) => {
    const lineCount = value ? value.split('\n').length || 1 : 1

    const lineNumbers = Array.from({ length: lineCount }, (_, i) => (
        <div key={i + 1} className="line-number">
            {i + 1}
        </div>
    ))

    if (!isVisible) {
        return null
    }

    return (
        <div className="line-numbers" ref={containerRef} style={style}>
            {lineNumbers}
        </div>
    )
}

export const LineNumberDisplay = memo(LineNumberDisplayComponent)
